import { combineReducers } from 'redux';
import paymentOptions from './paymentOptionsReducer';
import * as instrumentCheck from './instrumentCheckReducer';
import * as payWithDetails from './payWithDetailsReducer';
import * as payByInstrumentType from './payByInstrumentType';
import * as emiTerms from './emiTermsReducer';
import * as emiState from './emiStateReducer';
import * as captcha from './captchaReducer';
import * as emiCards from './emiCardsReducer';
import * as emiBanks from './emiBanksReducer';
import * as emiTenures from './emiTenuresReducer';
import * as emiItemLevelBreakup from './emiItemLevelBreakupReducer';
import * as netOptions from './netOptionsReducer';
import * as upiOptions from './upiOptionsReducer';
import * as upiPollState from './upiPollStateReducer';
import * as upiPollInfo from './upiPollInfoReducer';
import * as payViaWallet from './payViaWalletReducer';
import selectedPaymentOption from './selectedPaymentOptionReducer';
import * as adjustments from './adjustmentsReducer';
import paymentAsyncStatus from './paymentAsyncStatusReducer';
import * as otpModes from './otpModesReducer';
import * as otpSubmitState from './otpSubmitReducer';
import * as advancePaymentBreakup from './advancePaymentBreakupReducer';
import * as selectInstrument from './selectInstrumentReducer';
import * as errorOverlayReducer from './errorOverlayReducer';
import * as emiOnSavedCardsReducer from './emiOnSavedCardsReducer';
import * as emi2FAReducer from './emi2FAReducer';
import * as mobileWalletOptionsReducer from './mobileWalletOptionsReducer';
import * as mobileWalletOtpReducer from './mobileWalletOtpReducer';
import * as mobileWalletBalanceReducer from './mobileWalletBalanceReducer';

import {
	RESET_PAYMENT_OPTIONS,
	GET_PAYMENT_OPTIONS_REQUEST,
	VOUCHER_ADD_OR_SELECT_REQUEST
} from 'actions/PaymentActions/PaymentActions';

import { IPaymentTokenAction } from 'actions/paymentTokenActions';

// This is a higher order function that wraps the individual reducers and
// bypasses them when we need to "reset" the state of all the children. This is
// done to avoid endless repetition of adding these individual actions in each
// of the reducers. Before adding this function, there were cases where some
// reducers were not handling all the reset triggers, because of this
// repetition.
const wrapCommonActions = (reducerImport, useReducerState = false) => {
	return (state = reducerImport.INITIAL_STATE, action = {}) => {
		switch (action.type) {
			case IPaymentTokenAction.GET_PAYMENT_TOKEN_REQUEST:
			case RESET_PAYMENT_OPTIONS:
			case GET_PAYMENT_OPTIONS_REQUEST:
			case VOUCHER_ADD_OR_SELECT_REQUEST:
				return useReducerState ? reducerImport.default(state, action) : reducerImport.INITIAL_STATE;
			default:
				return reducerImport.default(state, action);
		}
	};
};

// When adding a new reducer to this list, do consider wrapping it in
// `wrapCommonActions` function. This requires you to export the reducer as the
// `default` export, and the default state as `INITIAL_STATE` as a member
// export.
const payment = combineReducers({
	paymentOptions,
	paymentAsyncStatus,
	selectedPaymentOption,
	instrumentCheck: wrapCommonActions(instrumentCheck),
	payWithDetails: wrapCommonActions(payWithDetails),
	payByInstrumentType: wrapCommonActions(payByInstrumentType),
	emiTerms: wrapCommonActions(emiTerms),
	emiState: wrapCommonActions(emiState),
	captcha: wrapCommonActions(captcha),
	emiCards: wrapCommonActions(emiCards),
	emiBanks: wrapCommonActions(emiBanks),
	emiTenures: wrapCommonActions(emiTenures),
	emiItemLevelBreakup: wrapCommonActions(emiItemLevelBreakup),
	netOptions: wrapCommonActions(netOptions),
	upiOptions: wrapCommonActions(upiOptions),
	upiPollState: wrapCommonActions(upiPollState),
	upiPollInfo: wrapCommonActions(upiPollInfo),
	payViaWallet: wrapCommonActions(payViaWallet),
	adjustments: wrapCommonActions(adjustments),
	otpModes: wrapCommonActions(otpModes),
	otpSubmitState: wrapCommonActions(otpSubmitState),
	advancePaymentBreakup: wrapCommonActions(advancePaymentBreakup),
	selectInstrument: wrapCommonActions(selectInstrument),
	errorOverlay: wrapCommonActions(errorOverlayReducer),
	emiOnSavedCards: wrapCommonActions(emiOnSavedCardsReducer),
	emi2FADetails: wrapCommonActions(emi2FAReducer),
	mobileWalletOptions: wrapCommonActions(mobileWalletOptionsReducer),
	mobileWalletOtpState: wrapCommonActions(mobileWalletOtpReducer),
	mobileWalletBalance: wrapCommonActions(mobileWalletBalanceReducer, true)
});

export default payment;
